/* tslint:disable */
 
import { Icon } from './icon';
import { LocalizedValue } from './localized-value';
import { NullableLocalizedValue } from './nullable-localized-value';

/**
 * (tsType: DuplicatedDataCollections, schemaOptions: { title: 'DuplicatedDataCollections' })
 */
export class DuplicatedDataCollections {
  description?: null | NullableLocalizedValue;
  icon?: null | Icon;
  name: LocalizedValue;
}
